import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYouTubeLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 256,
	height: 180,
	preserveAspectRatio: "xMidYMid",
	viewBox: "0 0 256 180",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "red",
		d: "M250.35 28.07a32.2 32.2 0 0 0-22.66-22.65C207.82 0 127.87 0 127.87 0S47.9.16 28.05 5.58A32.2 32.2 0 0 0 5.39 28.24c-6 35.3-8.34 89.08.16 122.97a32.2 32.2 0 0 0 22.66 22.66c19.87 5.41 99.82 5.41 99.82 5.41s79.96 0 99.82-5.41a32.2 32.2 0 0 0 22.66-22.66c6.34-35.35 8.3-89.1-.16-123.14"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#FFF",
		d: "m102.42 128.06 66.33-38.42-66.33-38.42z"
	})]
});
export { SvgYouTubeLogo as ReactComponent };
